module.exports = __webpack_public_path__ + "img/collapse.1aa97d26.svg";